export default {
    LOAD_NEWS_APP(state, news){
        state.items = news
    }
}